import { isSetEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'

/**
 * TODO:
 */
export const putCategoryGroups = store.effects.create(
  (feature: Collection['feature'], collection: Collection) =>
    collection.plugins.currentListPlugin.feature.selectors.entities.asObservable.pipe(
      rxjs.map(
        subcategories =>
          new Set(subcategories.map(subcategory => subcategory.categoryId)),
      ),
      rxjs.distinctUntilChanged((a, b) => isSetEqual(a, b)),
      rxjs.map(categoryIds =>
        collection.plugins.groupPlugin.feature.actions.put
          .from('putCategoryGroups (effect)')
          .create({
            groups: Array.from(categoryIds).map(categoryId => ({
              entitySelector: {
                predicate: subcategory => subcategory.categoryId === categoryId,
              },
              id: categoryId,
              name: categoryId,
            })),
          }),
      ),
    ),
)
